/**
 * @file 
 *
 */
'use strict';

/**
 * @classname ChangeInvoiceName
 * @classdesc 領収書宛名変更時の処理
 */
export default class ChangeInvoiceName {
	/**
	 * @constructor
	 * @param {jQuery} $e - .invoice-name
	 */
	constructor($e) {
		console.log('ChangeInvoiceName.constructor');
		this._$e = $e;
		this._$btnInvoice = $('#btn-invoice-download');
		$e.on('change', () => this.onChange());
		this.onChange();
	};


	/**
	 * change
	 *
	 * @memberof ChangeInvoiceName
	 * @return {undefined}
	 */
	onChange() {
		console.log('ChangeInvoiceName.onChange');
		const maxValidate = this._$e.attr('data-validate').split(' ').find(e => e.match(/^max-/));
		const max = maxValidate.split('-')[1];
		const valueLength = this._$e.val().length;
		if (0 < valueLength &&  valueLength <= max) {
			this._$btnInvoice.prop('disabled', false);
		} else {
			this._$btnInvoice.prop('disabled', true);
		}
	};
}
